import { useCallback, useState } from 'react';

/**
 * Local duplicate of the base `useToggle` from `ocfe/src/utilHooks/useToggle.ts`.
 * Kept here only so `@hl/ui-components` does not depend on the `ocfe` package; the OCFE file remains canonical for apps and other hooks in that module.
 */
export const useToggle = (init: boolean) => {
  const [isOn, setIsOn] = useState(init);
  const toggle = useCallback(() => setIsOn((on) => !on), []);
  const toggleOn = useCallback(() => setIsOn(true), []);
  const toggleOff = useCallback(() => setIsOn(false), []);
  return [isOn, toggle, toggleOn, toggleOff] as const;
};
